import {useMemo} from "react";
import {Input, InputGroup} from "rsuite";
import {Search} from "@rsuite/icons";

const styles = {
    margin: 10,
    width: 300,
};

const GridToolbar = (props) => {

    const { onSearchChange } = props;

    const GridSearchBox = ({ placeholder, onSearchChange, ...props }) => (
        <InputGroup {...props} inside style={styles}>
            <Input placeholder={placeholder} onChange={onSearchChange} />
            <InputGroup.Button>
                <Search />
            </InputGroup.Button>
        </InputGroup>
    );

    return useMemo(() => {
        return (
            <GridSearchBox size="md" placeholder="Search" onSearchChange={onSearchChange}/>
        );
    }, [onSearchChange]);
};

export default GridToolbar;